import React from 'react';
import './Navbar.css';
import { supportedLanguages } from '../i18n';

function Navbar({ t, language, setLanguage }) {

  return (

    <nav id="navbar" className="nav-container">
      <a href="#home" id="logo" className='logo'>nulamar</a>

      <div className="dropdown">
        <div className='dropdown-content'>
        <a href="#home" className="nav-link" onClick={hideItens}>{t.nav.home}</a>
        <a href="#about" className="nav-link" onClick={hideItens}>{t.nav.about}</a>
        <a href="#projects" className="nav-link" onClick={hideItens}>{t.nav.projects}</a>
        <a href="#contact" className="nav-link" onClick={hideItens}>{t.nav.contact}</a>
        </div>
        <label className="language-switcher" htmlFor="language-select">
          <span className="sr-only">Language</span>
          <select
            id="language-select"
            className="language-select"
            value={language}
            onChange={(event) => setLanguage(event.target.value)}
            aria-label="Select language"
          >
            {supportedLanguages.map((item) => (
              <option key={item} value={item}>
                {item.toUpperCase()}
              </option>
            ))}
          </select>
        </label>
        <button type="button" className="btTrans icon" onClick={lightModeFunction} aria-label="Toggle light mode">
          <i id="light-mode" className="fa-regular fa-lightbulb"></i>
        </button>

        <button type="button" className="dropbtn icon" onClick={showItens} aria-label="Open menu">
          <i className="fa fa-bars"></i>
        </button>

      </div>
    </nav>
  );

  //Função que altera tema da página. 
  //A variável element serve para definir qual elemento será alterado.
  function lightModeFunction() {
    var element = document.documentElement;
    element.classList.toggle("light-mode");
  }

  function showItens() {
    var x = document.getElementById("navbar");
    if (x.className === "nav-container") {
      x.className += " responsive";
    } else {
      x.className = "nav-container";
    }
  }

  function hideItens() {
    var x = document.getElementById("navbar");
    if (x.className.includes("responsive")) {
      x.className = "nav-container";
    }
  }

}

export default Navbar;
